import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkhedmidc() {



  const cardData =
  {
    keyword: ' Corporate cab Services in Khed MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate cab Services in Khed MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Khed MIDC, designed to support the transportation requirements of industrial plants, manufacturing units, and corporate offices in the area. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures comfortable, safe, and timely travel for employees, clients, and senior management. Whether it is daily employee commute, plant visits, airport transfers, or executive travel, we offer punctual, hassle-free, and customized mobility solutions. With experienced chauffeurs, flexible rental packages, and dedicated service support, Pune Corporate Cars India Private Limited delivers a seamless and premium travel experience for businesses operating in and around Khed MIDC.',

    top: 'Top Places to Visit in Khed with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Shivneri Fort",
    "description": "Shivneri Fort, located near Khed in Junnar, is one of Maharashtra’s most iconic historical sites and the birthplace of Chhatrapati Shivaji Maharaj. Surrounded by rugged hill ranges, the fort is known for its strong defensive walls, graceful gates, ancient water tanks, and scenic trekking paths. Visitors can explore the memorial dedicated to Shivaji Maharaj, enjoy panoramic views of the valley, and walk through places that once shaped the early years of the Maratha emperor’s life. The climb to Shivneri is moderate and rewarding, making it a perfect blend of history, nature, and adventure."
  },
  {
    "title": "Lenyadri Ganesh Temple",
    "description": "Lenyadri Ganpati Temple, one of the Ashtavinayak temples, is carved into a mountain cave near Khed and offers a spiritually uplifting experience. The temple is reached after climbing a long flight of steps carved directly into the hillside, giving pilgrims a scenic and memorable ascent. The shrine itself is part of a group of ancient Buddhist caves decorated with pillars and stone carvings, showcasing India’s ancient craftsmanship. The peaceful environment, hilltop breezes, and panoramic views of the valley make Lenyadri a favorite destination for devotees, trekkers, and heritage seekers alike."
  },
  {
    "title": "Ozar Vigneshwar Ganpati Temple",
    "description": "Located close to Khed, the Ozar Vigneshwar Temple is another Ashtavinayak pilgrimage site dedicated to Lord Ganesha. The temple features a traditional stone entrance, intricate carvings, a sacred sanctum, and a large courtyard that fills with vibrant energy during festivals. The nearby river and the peaceful village surroundings make the temple a relaxing and spiritually refreshing destination. Many pilgrims visit Lenyadri and Ozar in a single trip due to their close proximity, making this journey a culturally rich experience."
  },
  {
    "title": "Jungle Safari at Junnar Leopard Rescue Center",
    "description": "The Junnar Leopard Rescue Center near Khed is a wildlife conservation facility known for rehabilitating leopards that stray into farming and village areas. A visit offers an insightful look into animal conservation, human–wildlife coexistence, and the challenges of protecting natural habitats. Guided programs and forest tours may provide opportunities to learn about local wildlife, ecology, and forest ecosystems of the Western Ghats. It is an educational and unique experience for families, nature enthusiasts, and wildlife lovers."
  },
  {
    "title": "Vignahar Ganpati Temple, Khed",
    "description": "This beautiful temple dedicated to Lord Ganesha is one of Khed’s most important local religious landmarks. Surrounded by traditional village landscapes and a peaceful environment, the shrine offers a calming spiritual space for devotees. Community events and daily rituals keep the temple vibrant throughout the year, while the surrounding areas make for a quiet retreat from city life. The temple is often a stopover spot for travelers exploring nearby hill forts and pilgrim routes."
  },
  {
    "title": "Chavand Fort",
    "description": "Chavand Fort, located near Khed, is one of the forts captured during Chhatrapati Shivaji Maharaj’s early campaigns. Perched atop a steep hill, the fort rewards visitors with breathtaking views of the surrounding Sahyadri ranges and villages. Within the fort lies the revered Goddess Chamunda Temple, ancient water tanks, and remnants of stone fortifications. The trek to Chavand is both thrilling and scenic, making it popular among trekking groups and history explorers interested in Maratha-era heritage."
  },
  {
    "title": "Junnar Caves",
    "description": "The Junnar Buddhist caves, located close to Khed, form one of India’s largest cave complexes, with over 200 rock-cut chambers dating back to centuries before the common era. These caves served as ancient monastic residences for Buddhist monks, featuring prayer halls, meditation cells, stone carvings, and inscriptions. Walking through these caves feels like stepping back into ancient India’s scholarly and spiritual culture. Surrounded by hills and greenery, the site creates a peaceful blend of archaeology, religion, and nature."
  },
  {
    "title": "Kukadi Dam",
    "description": "Kukadi Dam is a scenic water reservoir near Khed, offering tranquil lakeside views surrounded by rural landscapes and green hillocks. The dam area is a popular spot for quiet evening walks, sunset viewing, and casual weekend outings. During monsoon, the region becomes lush and vibrant, with flowing streams and misty surroundings enhancing the overall experience. It is an excellent getaway for travelers looking for relaxation, photography, and time spent in natural surroundings."
  }
],


"services": [
{
"name": "Khed Employee Transport",
"description": "Khed Employee Transport offers highly organized daily commute solutions for employees working in Khed MIDC. With punctual routes, well-maintained vehicles, and trained drivers, the service ensures smooth shift-based travel and dependable workforce mobility for industries."
},
{
"name": "Khed Industrial Shuttle",
"description": "Khed Industrial Shuttle provides dedicated shuttle vans and minibuses designed for large-scale industrial staff movement. It supports multi-shift operations, structured pickup–drop points, and safe transportation for manufacturing and factory units in Khed MIDC."
},
{
"name": "Company Cab Khed MIDC",
"description": "Company Cab Khed MIDC delivers premium corporate cab solutions for businesses operating in Khed. It ensures reliable travel for employees, managers, and visitors with professional drivers, GPS-enabled cabs, and well-coordinated transportation schedules."
},
{
"name": "Staff Pickup Drop Khed",
"description": "Staff Pickup Drop Khed provides dependable pickup and drop services for daily office and factory staff. The service operates on fixed routes, shift timings, and safety-first protocols to ensure efficient and hassle-free commute management."
},
{
"name": "Affordable Cab Service Khed",
"description": "Affordable Cab Service Khed offers cost-effective cab solutions for local travel, employee commuting, and industrial visits. Companies and individuals benefit from budget-friendly pricing without compromising on punctuality or travel comfort."
},
{
"name": "Monthly Corporate Cab Khed",
"description": "Monthly Corporate Cab Khed provides long-term rental cabs for companies requiring consistent staff transportation. The service includes dedicated vehicles, fixed monthly plans, and continuous availability for uninterrupted workforce mobility."
},
{
"name": "Business Travel Cabs Khed MIDC",
"description": "Business Travel Cabs Khed MIDC offers professional transportation for corporate meetings, executive movements, and client visits. The fleet includes sedans, SUVs, and staff cabs suitable for all business travel needs in and around Khed."
},
{
"name": "Worker Commute Khed",
"description": "Worker Commute Khed specializes in large-scale worker mobility with structured routes, shift-wise schedules, and safety-focused transport operations. It ensures timely commute for factory and industrial workers across Khed MIDC."
},
{
"name": "Best Corporate Cab Khed",
"description": "Best Corporate Cab Khed delivers top-tier transportation solutions with premium vehicles, professional chauffeurs, and on-time service. Ideal for executive travel, client movements, and high-standard corporate commuting requirements."
},
{
"name": "Outstation Cab Khed MIDC",
"description": "Outstation Cab Khed MIDC offers comfortable long-distance travel services for intercity business trips, factory visits, and corporate travel. With reliable drivers and well-maintained vehicles, the service ensures safe and seamless journeys."
},
{
"name": "Sedan Cab Khed",
"description": "Sedan Cab Khed provides premium sedan-class vehicles designed for executive and managerial travel. The service ensures smooth, comfortable, and professional transportation within Khed and nearby regions."
},
{
"name": "SUV Cab Khed",
"description": "SUV Cab Khed offers spacious and powerful SUVs ideal for team travel, long-distance corporate trips, and industrial visits. The service ensures comfort, durability, and ample space for group movements."
},
{
"name": "Factory Transport Khed",
"description": "Factory Transport Khed supports large factories and industrial units with high-capacity staff commuting, structured routing, and shift-based operations. It ensures dependable, safe, and well-managed daily workforce transportation."
},
{
"name": "Corporate Travel Khed MIDC",
"description": "Corporate Travel Khed MIDC delivers complete travel solutions for companies, including executive transport, staff cabs, business trip support, and visitor mobility. It ensures professional, comfortable, and efficient corporate travel management."
},
{
"name": "Employee Shuttle Khed",
"description": "Employee Shuttle Khed provides shuttle vans and minibuses for bulk employee movement, designed for factories, warehouses, and corporate units. The service ensures timely shift operations, safe group travel, and organized commute planning."
}
],

"tableData": [
["Khed Employee Transport", "Khed Industrial Shuttle"],
["Company Cab Khed MIDC", "Staff Pickup Drop Khed"],
["Affordable Cab Service Khed", "Monthly Corporate Cab Khed"],
["Business Travel Cabs Khed MIDC", "Worker Commute Khed"],
["Best Corporate Cab Khed", "Outstation Cab Khed MIDC"],
["Sedan Cab Khed", "SUV Cab Khed"],
["Factory Transport Khed", "Corporate Travel Khed MIDC"],
["Employee Shuttle Khed", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Khed MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable corporate cab services for employees and executives commuting to Khed MIDC, ensuring timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drops, helping your corporate staff reach their offices in Khed MIDC efficiently and reliably."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, making every corporate journey comfortable and secure."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Our fleet includes sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate commuting."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to the commuting requirements of businesses and employees in Khed MIDC."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for scheduling, emergencies, and route adjustments, ensuring smooth and uninterrupted travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for your employees."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is simplified with our streamlined booking process and seamless coordination, making employee transport stress-free."
  }
]






























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Khed MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and well-managed corporate cab services for companies operating in Khed MIDC.',
  },
  {
    question: 'What types of corporate cab services are offered in Khed MIDC?',
    answer: 'We offer employee transportation, corporate pickups and drops, shift-based cabs, and dedicated fleet services for Khed MIDC companies.',
  },
  {
    question: 'Do you support employee shift transportation for Khed MIDC?',
    answer: 'Yes, we provide cab services tailored for multiple shifts including early morning, evening, and night shifts.',
  },
  {
    question: 'How can companies book corporate cab services for Khed MIDC?',
    answer: 'Companies can book services through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Khed MIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and mini-buses based on staff strength and corporate requirements.',
  },
  {
    question: 'Do you provide long-term transportation contracts for Khed MIDC?',
    answer: 'Yes, we offer monthly, quarterly, and annual transportation contracts with flexible and transparent pricing.',
  },
  {
    question: 'Are safety features included in corporate cab services?',
    answer: 'Yes, all vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs.',
  },
  {
    question: 'Can companies schedule regular cab routes for employees?',
    answer: 'Absolutely. We customize routes and schedules based on employee locations and company shift timings.',
  },
  {
    question: 'What payment options are available for corporate cab services in Khed MIDC?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and offer monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Parab',
    feedback: 'Outstanding corporate cab service for our Khed MIDC facility. Timely pickups and excellent driver conduct.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kelkar',
    feedback: 'Very dependable employee transportation service. Pune Corporate Cars India Private Limited handles our shifts smoothly every day.',
    rating: 5,
  },
];



















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Khed MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-khed.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Khed MIDC, Pune, including employee transport, industrial shuttle services, staff pickup and drop, office and factory commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely corporate transport.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-khed-midc"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Khed MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides reliable corporate cab services in Khed MIDC, Pune, including employee transport, industrial shuttle services, staff pickup and drop, office and factory commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely corporate transport."
  />

  <meta
    name="keywords"
    content="Khed Employee Transport, Khed Industrial Shuttle, Company Cab Khed MIDC, Staff Pickup Drop Khed, Affordable Cab Service Khed, Monthly Corporate Cab Khed, Business Travel Cabs Khed MIDC, Worker Commute Khed, Best Corporate Cab Khed, Outstation Cab Khed MIDC, Sedan Cab Khed, SUV Cab Khed, Factory Transport Khed, Corporate Travel Khed MIDC, Employee Shuttle Khed"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinkhedmidc;